var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "shensu-info",
    },
    [
      _vm.detail.auditStatus === 0
        ? [
            _c("div", { staticClass: "shensu-top" }, [
              _c("img", {
                staticClass: "img",
                attrs: {
                  src: "https://fenxiao.muruji.com/internalSystem/c4d0998c-1e84-4767-ac47-45347fcb3b59",
                },
              }),
              _c("div", { staticClass: "shensu-title" }, [_vm._v("审核中...")]),
              _c("div", { staticClass: "shensu-tips" }, [
                _vm._v("正在审批该订单的提成改为"),
                _c("span", { staticClass: "danger" }, [
                  _vm._v(_vm._s(_vm.detail.bonusTypeLabel)),
                ]),
                _vm._v("的申请。"),
              ]),
            ]),
            _c("div", { staticClass: "shensu-content" }, [
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "lable" }, [_vm._v("图片证据：")]),
                _c(
                  "div",
                  { staticClass: "img-list" },
                  _vm._l(_vm.detail.urls, function (url, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "img" },
                      [
                        _c("el-image", {
                          staticClass: "image",
                          attrs: { src: url, fit: "contain" },
                        }),
                        _c("div", { staticClass: "look" }, [_vm._v("查看")]),
                        _c("el-image", {
                          staticClass: "image image-click",
                          attrs: {
                            src: url,
                            fit: "contain",
                            "preview-src-list": _vm.detail.urls,
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ]),
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "lable" }, [_vm._v("申诉备注：")]),
                _c("div", { staticClass: "text" }, [
                  _vm._v(_vm._s(_vm.detail.reason)),
                ]),
              ]),
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "lable" }, [_vm._v("提交审核人：")]),
                _c("div", { staticClass: "text" }, [
                  _vm._v(_vm._s(_vm.detail.applyName)),
                ]),
              ]),
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "lable" }, [_vm._v("提交时间：")]),
                _c("div", { staticClass: "text" }, [
                  _vm._v(_vm._s(_vm.detail.applyTime)),
                ]),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "button-con" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "btn-cancel",
                    on: {
                      click: function ($event) {
                        return _vm.$emit("dialogVisible")
                      },
                    },
                  },
                  [_vm._v("取 消")]
                ),
                _vm.detail.applyName === _vm.userInfo.reallyName
                  ? _c(
                      "el-button",
                      {
                        staticClass: "btn-ok",
                        attrs: { type: "primary" },
                        on: { click: _vm.cancelApply },
                      },
                      [_vm._v("撤销申诉")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        : _vm._e(),
      _vm.detail.auditStatus === 1
        ? [
            _vm._m(0),
            _c("div", { staticClass: "shensu-content" }, [
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "lable" }, [_vm._v("图片证据：")]),
                _c(
                  "div",
                  { staticClass: "img-list" },
                  _vm._l(_vm.detail.urls, function (url, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "img" },
                      [
                        _c("el-image", {
                          staticClass: "image",
                          attrs: { src: url, fit: "contain" },
                        }),
                        _c("div", { staticClass: "look" }, [_vm._v("查看")]),
                        _c("el-image", {
                          staticClass: "image image-click",
                          attrs: {
                            src: url,
                            fit: "contain",
                            "preview-src-list": _vm.detail.urls,
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ]),
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "lable" }, [_vm._v("申诉备注：")]),
                _c("div", { staticClass: "text" }, [
                  _vm._v(_vm._s(_vm.detail.reason)),
                ]),
              ]),
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "lable" }, [_vm._v("撤销审核人：")]),
                _c("div", { staticClass: "text" }, [
                  _vm._v(_vm._s(_vm.detail.applyName)),
                ]),
              ]),
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "lable" }, [_vm._v("撤销时间：")]),
                _c("div", { staticClass: "text" }, [
                  _vm._v(_vm._s(_vm.detail.applyTime)),
                ]),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "button-con" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "btn-cancel",
                    on: {
                      click: function ($event) {
                        return _vm.$emit("dialogVisible")
                      },
                    },
                  },
                  [_vm._v("取 消")]
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
      _vm.detail.auditStatus === 2
        ? [
            _c("div", { staticClass: "shensu-top" }, [
              _c("img", {
                staticClass: "img",
                attrs: {
                  src: "https://fenxiao.muruji.com/internalSystem/84cfe386-00bd-4c92-b0e3-ea1dac4051a0",
                },
              }),
              _c("div", { staticClass: "shensu-title shensu-title-success" }, [
                _vm._v("审核结果：" + _vm._s(_vm.detail.auditStatusLabel)),
              ]),
              _c("div", { staticClass: "shensu-tips" }, [
                _vm._v("系统提成类型更改为"),
                _c("span", { staticClass: "danger" }, [
                  _vm._v(_vm._s(_vm.detail.bonusTypeLabel)),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "shensu-content" }, [
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "lable" }, [_vm._v("图片证据：")]),
                _c(
                  "div",
                  { staticClass: "img-list" },
                  _vm._l(_vm.detail.urls, function (url, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "img" },
                      [
                        _c("el-image", {
                          staticClass: "image",
                          attrs: { src: url, fit: "contain" },
                        }),
                        _c("div", { staticClass: "look" }, [_vm._v("查看")]),
                        _c("el-image", {
                          staticClass: "image image-click",
                          attrs: {
                            src: url,
                            fit: "contain",
                            "preview-src-list": _vm.detail.urls,
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ]),
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "lable" }, [_vm._v("申诉备注：")]),
                _c("div", { staticClass: "text" }, [
                  _vm._v(_vm._s(_vm.detail.reason)),
                ]),
              ]),
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "lable" }, [_vm._v("审核人：")]),
                _c("div", { staticClass: "text" }, [
                  _vm._v(_vm._s(_vm.detail.auditUserName)),
                ]),
              ]),
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "lable" }, [_vm._v("审核时间：")]),
                _c("div", { staticClass: "text" }, [
                  _vm._v(_vm._s(_vm.detail.applyTime)),
                ]),
              ]),
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "lable" }, [_vm._v("审核备注：")]),
                _c("div", { staticClass: "text" }, [
                  _vm._v(_vm._s(_vm.detail.auditRemarks)),
                ]),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "button-con" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "btn-ok",
                    attrs: { type: "primary", plain: "" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("dialogVisible")
                      },
                    },
                  },
                  [_vm._v("好 的")]
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
      _vm.detail.auditStatus === 3
        ? [
            _c("div", { staticClass: "shensu-top" }, [
              _c("img", {
                staticClass: "img",
                attrs: {
                  src: "https://fenxiao.muruji.com/internalSystem/504f2ae5-1656-4515-8eab-b243fc95139f",
                },
              }),
              _c("div", { staticClass: "shensu-title shensu-title-danger" }, [
                _vm._v("审核结果：" + _vm._s(_vm.detail.auditStatusLabel)),
              ]),
              _c("div", { staticClass: "shensu-tips" }, [
                _vm._v("提成申诉失败，订单提成仍为"),
                _c("span", { staticClass: "danger" }, [
                  _vm._v(_vm._s(_vm.detail.oldBonusTypeLabel)),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "shensu-content" }, [
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "lable" }, [_vm._v("图片证据：")]),
                _c(
                  "div",
                  { staticClass: "img-list" },
                  _vm._l(_vm.detail.urls, function (url, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "img" },
                      [
                        _c("el-image", {
                          staticClass: "image",
                          attrs: { src: url, fit: "contain" },
                        }),
                        _c("div", { staticClass: "look" }, [_vm._v("查看")]),
                        _c("el-image", {
                          staticClass: "image image-click",
                          attrs: {
                            src: url,
                            fit: "contain",
                            "preview-src-list": _vm.detail.urls,
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ]),
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "lable" }, [_vm._v("申诉备注：")]),
                _c("div", { staticClass: "text" }, [
                  _vm._v(_vm._s(_vm.detail.reason)),
                ]),
              ]),
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "lable" }, [_vm._v("审核人：")]),
                _c("div", { staticClass: "text" }, [
                  _vm._v(_vm._s(_vm.detail.auditUserName)),
                ]),
              ]),
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "lable" }, [_vm._v("审核时间：")]),
                _c("div", { staticClass: "text" }, [
                  _vm._v(_vm._s(_vm.detail.applyTime)),
                ]),
              ]),
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "lable" }, [_vm._v("审核备注：")]),
                _c("div", { staticClass: "text" }, [
                  _vm._v(_vm._s(_vm.detail.auditRemarks)),
                ]),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "button-con" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "btn-ok",
                    attrs: { type: "primary", plain: "" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("dialogVisible")
                      },
                    },
                  },
                  [_vm._v("好 的")]
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
      _vm.detail.auditStatus === 4
        ? [
            _c("div", { staticClass: "shensu-top" }, [
              _c("img", {
                staticClass: "img",
                attrs: {
                  src: "https://fenxiao.muruji.com/internalSystem/a2b91ead-64de-4729-bc7f-eac4db967a7c",
                },
              }),
              _c("div", { staticClass: "shenhe-tips" }, [
                _vm._v("系统提成类型更改为"),
                _c("span", { staticClass: "danger" }, [
                  _vm._v(_vm._s(_vm.detail.bonusTypeLabel)),
                ]),
                _vm._v("。"),
              ]),
            ]),
            _c("div", { staticClass: "shensu-content" }, [
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "lable" }, [_vm._v("图片证据：")]),
                _c(
                  "div",
                  { staticClass: "img-list" },
                  _vm._l(_vm.detail.urls, function (url, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "img" },
                      [
                        _c("el-image", {
                          staticClass: "image",
                          attrs: { src: url, fit: "contain" },
                        }),
                        _c("div", { staticClass: "look" }, [_vm._v("查看")]),
                        _c("el-image", {
                          staticClass: "image image-click",
                          attrs: {
                            src: url,
                            fit: "contain",
                            "preview-src-list": _vm.detail.urls,
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ]),
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "lable" }, [_vm._v("修改备注：")]),
                _c("div", { staticClass: "text" }, [
                  _vm._v(_vm._s(_vm.detail.reason)),
                ]),
              ]),
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "lable" }, [_vm._v("修改人：")]),
                _c("div", { staticClass: "text" }, [
                  _vm._v(_vm._s(_vm.detail.applyName)),
                ]),
              ]),
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "lable" }, [_vm._v("修改时间：")]),
                _c("div", { staticClass: "text" }, [
                  _vm._v(_vm._s(_vm.detail.applyTime)),
                ]),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "button-con" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "btn-ok",
                    attrs: { type: "primary", plain: "" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("dialogVisible")
                      },
                    },
                  },
                  [_vm._v("好 的")]
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "shensu-top" }, [
      _c("img", {
        staticClass: "img",
        attrs: {
          src: "https://fenxiao.muruji.com/internalSystem/0985f322-bc3d-4fce-a4f0-a33fc0619288",
        },
      }),
      _c("div", { staticClass: "shensu-title shensu-title-cancel" }, [
        _vm._v("撤销申诉"),
      ]),
      _c("div", { staticClass: "shensu-tips" }, [
        _vm._v("您已撤销订单的提成变更的申请。"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }